import React, { useContext, useEffect, useState } from "react";
import { Drawer, message,DatePicker, TimePicker, Select, Input, Button, InputNumber } from "antd";
import {CloseOutlined, EnvironmentOutlined} from '@ant-design/icons';
import {isEmpty, map, orderBy, cloneDeep} from "lodash";
import * as yup from 'yup'
import axios from "../../../../../Lib/axios";
import Loader from "../../../../Common/Component/Loader";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";
import DefineLocation from "../../../ProposalDetail/Component/Service/Proposal/DefineLocation";
import DefineCoordinates from "../../../ProposalDetail/Component/Service/Proposal/DefineCoordinates";
import addGreenCircle from '../../../../../Assets/images/add-circle-outline-green.svg';
import EditGreen from '../../../../../Assets/images/edit-pencil-green.svg';
import { DeleteFilled} from '@ant-design/icons';
import AllState from "../../../../../Assets/data/stateList.json";
import moment from 'moment';
import workOrderStatus from '../../../../Common/workOrderStatus.json';
import TextArea from "antd/lib/input/TextArea";
import CurrencyFormat from 'react-currency-format';
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";
const PageContext = React.createContext();

const { Option } = Select;

export default function ServiceDetails(props) {
  const [state, setState] = useState({ errors: {} });
  const [loader, setLoader] = useState(false);
  return (
    <PageContext.Provider value={{ state, setState, loader, setLoader, clearState: () => { setState({ errors: {} }) }, ...props }}>
      <ServiceDetails_ />
    </PageContext.Provider>
  )
}

const PRODUCT_TYPE_MAPPING = [
  { value: 'pet_waste_stations', key: 'Pet Waste Stations' },
  { value: 'pet_waste_station_bags', key: 'Pet Waste Station Bags' },
  { value: 'other', key: 'other' }
]

const SERVICE_TYPE_MAPPING = [
  { value: 'pet_waste_station_service', key: 'Pet Waste Station Service' },
  { value: 'common_area_cleaning', key: 'Common Area Cleaning' },
  { value: 'trash_can_service', key: 'Trash Can Service' },
  { value: 'repair', key: 'Repair' },
  { value: 'other', key: 'other' }
]

const PRODUCT_TYPE = {
  'pet_waste_stations': 'Pet Waste Stations',
  'pet_waste_station_bags': 'Pet Waste Station Bags',
  'other': 'other'
}

const SERVICE_TYPE = {
  'pet_waste_station_service': 'Pet Waste Station Service',
  'common_area_cleaning': 'Common Area Cleaning',
  'trash_can_service': 'Trash Can Service',
  'repair': 'Repair',
  'other': 'other'
}

function ServiceDetails_() {
  const ctx = useContext(PageContext);
  const [field_office__uuid, setField_office__uuid] = useState('');
  const {
    state,
    setState,
    loader,
    setLoader,
    transection_type,
    visible_edit_workOrder,
    workorder_uuid,
    selectedService,
    goback = () => { }
  } = ctx;
  const {
    uuid,
    date,
    time,
    header_bag_price,
    roll_bag_price,
    header_bag_quantity,
    roll_bag_quantity,
    technician,
    technician_uuid,
    status,
    security_code,
    commercial_work_order_line_items = [],
    original_data= [],
    scheduled_time,
    is_auto_invoice_genrated,
    bill_for_cancelization,
    is_time_null,
    cleaning_notes,
    work_order_number,
    commercial_service_coordinates,
    service_order = {},
    service_order_uuid,
    total_header_bags_sold,
    total_roll_bags_sold,
    total,
    commercial_order_line_item_type = "service",
    showCoordinates = false,
    coordinateIndex=0,
    coordinate={
      image: '',
      pdf: '',
      markers: []
    }, 
    is_button_clicked = false
  } = state;

  const workorder_status = [
    "tentative",
    "scheduled",
    "technician_assigned",
    "technician_en_route",
    "in_progress",
    "complete",
    "incomplete"
  ]
  const time_status = [
    "tentative",
    "scheduled",
    "technician_assigned",
    "technician_en_route",
    "in_progress",
    "complete",
    "incomplete"
  ]
  
  useEffect(() => {
    setLoader(true);
    if (transection_type === "Edit" || transection_type === "View") {
      axios.get(`/commercial-workorder/${workorder_uuid}`)
        .then(response => {
          let allMarkrs=[];
          map(response?.data?.commercial_work_order_line_items, (line_items) => {
            line_items.markers=getTotalForCoordinated(line_items.coordinates);
            line_items.totalCoordinates=line_items.markers.length;
          });
          let status = '';
          if (response?.data?.status === 'cancelled' && !response?.data?.bill_for_cancelization) {
            status = 'cancelled_non_billable';
          } else if (response?.data?.status === 'cancelled' && response?.data?.bill_for_cancelization && !response?.data?.is_auto_invoice_genrated) {
            status = 'cancelled_billable';
          } else if (response?.data?.status === 'cancelled' && response?.data?.is_auto_invoice_genrated) {
            status = 'Cancelled Billed';
          } else {
            status = response?.data?.status;
          }
          setState(s => ({
            ...s,
            uuid: response?.data?.uuid || '',
            date: response?.data?.date || '',
            time: response?.data?.time ? selectedService?.commercial_order_line_item_type==='service'? moment(response?.data?.time, "hh:mm") || undefined : undefined : undefined,
            header_bag_price: response?.data?.header_bag_price || 0,
            roll_bag_price: response?.data?.roll_bag_price || 0,
            header_bag_quantity: response?.data?.header_bag_quantity || 0,
            roll_bag_quantity: response?.data?.roll_bag_quantity || 0,
            technician: response?.data?.technician || null,
            technician_uuid: response?.data?.technician_uuid || null,
            status: status,
            security_code: response?.data?.security_code || '',
            commercial_work_order_line_items: [...response?.data?.commercial_work_order_line_items] || [],
            original_data: [...response?.data?.commercial_work_order_line_items] || [],
            scheduled_time: response?.data?.scheduled_time || '',
            is_auto_invoice_genrated: response?.data?.is_auto_invoice_genrated || false,
            bill_for_cancelization: response?.data?.bill_for_cancelization || false,
            is_time_null: response?.data?.is_time_null || true,
            cleaning_notes: response?.data?.cleaning_notes || '',
            work_order_number: response?.data?.work_order_number || '',
            commercial_service_coordinates: response?.data?.commercial_service_coordinates ? getTotalForCoordinated(response?.data?.commercial_service_coordinates): '',
            service_order: response?.data?.service_order || '',
            service_order_uuid: response?.data?.service_order_uuid || '',
            total_header_bags_sold: response?.data?.total_header_bags_sold || '',
            total_roll_bags_sold: response?.data?.total_roll_bags_sold || '',
            total: response?.data?.total || 0,
            commercial_order_line_item_type: selectedService?.commercial_order_line_item_type,
            transection_type:transection_type,
            showCoordinates:false,
            coordinateIndex:0,
            coordinate:{
              image: '',
              pdf: '',
              markers: []
            },
            currentPosition :response?.data?.service_order?.service_address?.geo_location?.latitude?{lat: response?.data?.service_order?.service_address?.geo_location?.latitude, lng: response?.data?.service_order?.service_address?.geo_location?.longitude}:{},
            is_button_clicked: false,
            currentSelectedDate:response?.data?.date || '',
          }));
          setLoader(false);
          setField_office__uuid(response?.data?.service_order?.field_office__uuid);
        })
        .catch(error => {
          console.error(error)
          setLoader(false);
        })
    } else if (transection_type === "Create") {
      setState(s => ({
        ...s,
        uuid: '',
        date: '',
        time: '',
        header_bag_price: selectedService?.header_bag_price || 0,
        roll_bag_price: selectedService?.roll_bag_price || 0,
        header_bag_quantity: 0,
        roll_bag_quantity: 0,
        technician: null,
        technician_uuid: null,
        status: selectedService?.commercial_order_line_item_type === "service" ? 'forecast' : 'incomplete',
        security_code: '',
        commercial_work_order_line_items: [],
        original_data: [],
        scheduled_time: '',
        is_auto_invoice_genrated: false,
        bill_for_cancelization: false,
        is_time_null: true,
        cleaning_notes: '',
        work_order_number: '',
        commercial_service_coordinates: '',
        service_order: '',
        service_order_uuid: '',
        total_header_bags_sold: '',
        total_roll_bags_sold: '',
        total: 0,
        commercial_order_line_item_type: selectedService?.commercial_order_line_item_type,
        transection_type:'Create',
        showCoordinates:false,
        coordinateIndex:0,
        coordinate:{
          image: '',
          pdf: '',
          markers: []
        },
        is_button_clicked: false,
        currentPosition :selectedService?.service_address?.geo_location?.latitude?{lat: selectedService?.service_address?.geo_location?.latitude, lng: selectedService?.service_address?.geo_location?.longitude}:{},
        currentSelectedDate:'',
      }));
      setField_office__uuid(selectedService.field_office__uuid);
      setLoader(false);
    }
  }, [])

  
  const getTotalForCoordinated=(item)=>{
    var _markers = [], multiple_locations = item;
    let locations = multiple_locations?.split('MULTIPOINT')[1];
    locations = locations?.trim().substr(1, locations.trim().length - 2);
    let temp = locations?.split(', ');
    map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}));
    return _markers;
  }

  const isAltered = () => {
    let is_altered = false;

    if(commercial_work_order_line_items?.length > 0)
    {
      commercial_work_order_line_items.forEach(item => 
      {
        const index = original_data.findIndex(element => item.uuid === element.uuid);

        if(item.quantity !== original_data[index].quantity)
        {
         is_altered = true;
        }

        if(item.description !== original_data[index].description)
        {
         is_altered = true;
        }

        if(item.rate !== original_data[index].rate)
        {
         is_altered = true;
        }

        if(item.totalCoordinates !== original_data[index].totalCoordinates || item.coordinates !== original_data[index].coordinates)
        {
         is_altered = true;
        }

        if(parseFloat(item.total) !== parseFloat(original_data[index].total))
        {
         is_altered = true;
        }

        if(item.miscellaneous_services?.length !== original_data[index].miscellaneous_services.length)
        {
         is_altered = true;
        }

        if(item.miscellaneous_services?.length > 0)
        {
          item.miscellaneous_services.forEach( new_element => {
            let was_found = original_data[index].miscellaneous_services.findIndex(element => {
              return element.item === new_element.item && element.mis_type === new_element.mis_type && element.price === new_element.price;
            })

            if(was_found < 0)
            {
              is_altered = true;
              return;
            }
          });
        }
      });
    }

    return is_altered;
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const validate = () => {
    if (commercial_work_order_line_items && commercial_work_order_line_items.length === 0) {
      message.error(`You must add at least one ${commercial_order_line_item_type}`, 10);
      setState(s => ({ ...s, is_button_clicked: false }));
      setLoader(false);
    } else {
      let selectedTime = moment(time).format("hh:mm a") === "Invalid date" ? time : moment(time).format("hh:mm a");
      let selectedDate = status === 'forecast' ? date : `${date} ${selectedTime}`;
      let isPastDate = false;
      let isFutureDate = false;
      if (status === 'forecast') {
        isPastDate = moment(date, "YYYY/MM/DD").isBefore(moment(new Date()).format("YYYY/MM/DD"));
        console.warn('forecast - isPastDate', isPastDate, 'scheduled', selectedDate)
      }
      // if (status === 'scheduled') {
      //   isPastDate = moment(selectedDate).isBefore(moment(new Date()).format("YYYY/MM/DD hh:mm a"));
      //   console.warn('scheduled- isPastDate', isPastDate, 'scheduled', selectedDate)
      // }
      if (status === 'complete' || status === 'incomplete' || status==='cancelled_billable') {
        isFutureDate = !moment(date, "YYYY/MM/DD").isBefore(moment());
      }
      
      //add default time if line item type is product
      if(commercial_order_line_item_type === "product" &&  time_status.indexOf(status) > -1 && !state?.time ){
        state.time = moment("12:00 AM", ["h:mm A"]);
      }
      const schema = yup.object().shape({
        date: yup.string().required('Select date.'),
        status: yup.string().required('Please select valid status.'),
        time:commercial_order_line_item_type === "service" || commercial_order_line_item_type === "product" ? time_status.indexOf(status) > -1 && !state?.time ? yup.string().required('Select time.') : null:null,
        time_past: commercial_order_line_item_type === "service" || commercial_order_line_item_type === "product" ? isPastDate && (time || status === 'forecast') ? yup.string().required('Work orders in this status cannot have a date/time in the past.') : null : null,
        time_future: commercial_order_line_item_type === "service" || commercial_order_line_item_type === "product" ? isFutureDate && date ? yup.string().required('Work orders in this status cannot have a date/time in the future.') : null : null,
        // technician: commercial_order_line_item_type === "service" ? workorder_status.indexOf(status) > -1 && !technician_uuid ? yup.string().required('Please select assigned technician.') : null : null,
        ...(commercial_order_line_item_type === "service" ? { technician: workorder_status.indexOf(status) > -1 && !technician_uuid ? yup.string().required('Please select assigned technician.'): null } : null),
        ...(commercial_order_line_item_type === "service" ? { header_bag_price: yup.string().typeError('Enter header bag price.').required('Enter header bag price.') } : null),
        ...(commercial_order_line_item_type === "service" ? { roll_bag_price: yup.string().typeError('Enter roll bag price.').required('Enter roll bag price.') } : null),
        ...(commercial_order_line_item_type === "service" ? { header_bag_quantity: yup.string().typeError('Enter header bag quantity.').required('Enter header bag quantity.') } : null),
        ...(commercial_order_line_item_type === "service" ? { roll_bag_quantity: yup.string().typeError('Enter roll bag quantity.').required('Enter roll bag quantity.') } : null),
        commercial_work_order_line_items: yup.array(yup.object({
          service_name: yup.string().required('Select service'),
          quantity: yup.number().typeError('Enter quantity').required('Enter quantity') .test(
            'Is positive?', 
            'Quantity must be greater than 0!', 
            (value) => value > 0
          ),
          rate: yup.number().typeError('Enter rate').required('Enter rate'),
          ...(commercial_order_line_item_type === "service" ? { coordinates:yup.string().typeError('Enter coordinates').required('Enter coordinates')} : null),
          ...(commercial_order_line_item_type === "product" ? {shipping_and_handling:yup.number().typeError('Enter shipping and handling').required('Enter shipping and handling')} : null),
          ...(commercial_order_line_item_type === "product" ? {model:yup.string().typeError('Select model').required('Select model')} : null),
          miscellaneous_services: yup.array(yup.object({
            mis_type:yup.string().oneOf(["product", "service"]).required('Select one'),
            item: yup.string().required('Enter item'),
            price: yup.number().typeError('Enter valid price').required('Enter price'),
          })),
        }))
      });

      const data = { date: date || '', time, status, header_bag_price, roll_bag_price, header_bag_quantity, roll_bag_quantity, commercial_work_order_line_items };
      schema.validate(data, { abortEarly: false }).then(() => {
        setState(s => ({ ...s, errors: {} }));
        if (transection_type === "Create") {
          createWorkOrder();
        } else if (transection_type === "Edit") {
          updateWorkOrder();
        }
      }).catch((error) => {
        console.log(error);
        setState(s => ({ ...s, errors: error, is_button_clicked: false }));
        setLoader(false);
      })
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const createWorkOrder = () => {
    setLoader(true);
    const params = {
      "date": state?.date ? moment(state?.date).format("YYYY-MM-DD") : null,
      "header_bag_price": state?.header_bag_price || 0,
      "roll_bag_price": state?.roll_bag_price || 0,
      "roll_bag_quantity": state?.roll_bag_quantity || 0,
      "status": (state?.status === 'cancelled_non_billable' || state?.status === 'cancelled_billable') ? 'cancelled' : state?.status,
      "security_code": state?.security_code || '',
      "is_time_null": false,
      "cleaning_notes": state?.cleaning_notes || '',
      "service_order_uuid": selectedService.uuid || null,
      ...(state?.technician_uuid ? { technician_uuid: state?.technician_uuid} : null),
      ...(state?.time ? { time: moment(state?.time).format("HH:mm:ss") === "Invalid date" ? state?.time : moment(state?.time).format("HH:mm:ss")} : null),
      ...(commercial_work_order_line_items && commercial_work_order_line_items.length > 0 ? {commercial_work_order_line_items: commercial_work_order_line_items} : null),
      ...(state?.status === 'complete_and_billed' ? { is_auto_invoice_genrated: true} : null),
      ...(state?.status === 'complete_and_not_billed' ? { is_auto_invoice_genrated: false} : null),
      ...(state?.status === 'cancelled_non_billable' ? { bill_for_cancelization: false} : null),
      ...(state?.status === 'cancelled_billable' ? { bill_for_cancelization: true, is_auto_invoice_genrated: false} : null),
    };
    const data = filterParams(params);
    axios.post(`/commercial-workorder/`, data).then((response) => {
      message.success(`Work order ${response?.data?.work_order_number || ""} created.`, 10);
      setTimeout(() => {
        setLoader(false);
        setState(s => ({ ...s, is_button_clicked: false }));
        goback();
      }, 1000);
    }).catch(error => {
      setLoader(false);
      setState(s => ({ ...s, is_button_clicked: false }));
      message.error(`Error occurred while creating Work order.`, 30);
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const updateWorkOrder = () => {
    setLoader(true);
  
    console.log(isAltered());

    const data = {
      is_altered: isAltered(),
      service_order_uuid: selectedService.uuid,
      "status": (status === 'cancelled_non_billable' || status === 'cancelled_billable') ? 'cancelled' : status,
      date: date ? moment(date).format("YYYY-MM-DD") : null,
      cleaning_notes: cleaning_notes,
      security_code: security_code,
      header_bag_price: header_bag_price,
      roll_bag_price: roll_bag_price,
      header_bag_quantity: header_bag_quantity,
      roll_bag_quantity: roll_bag_quantity,
    };
    if (status === 'complete_and_billed') {
      data['is_auto_invoice_genrated'] = true;
    }
    if (status === 'complete_and_not_billed') {
      data['is_auto_invoice_genrated'] = false;
    }
    if (status === 'cancelled_non_billable') {
      data['bill_for_cancelization'] = false;
    }
    if (status === 'cancelled_billable') {
      data['bill_for_cancelization'] = true;
      data['is_auto_invoice_genrated'] = false;
    }
    if (technician_uuid) {
      data['technician_uuid'] = technician_uuid;
    }
    if (time) {
      data['time'] = moment(time).format("HH:mm:ss") === "Invalid date" ? time : moment(time).format("HH:mm:ss");
    }
    if (commercial_work_order_line_items && commercial_work_order_line_items.length > 0) {
      data['commercial_work_order_line_items'] = commercial_work_order_line_items;
    }
    axios.patch(`/commercial-workorder/${uuid}/`, data).then((response) => {
      message.success(`Work order ${response?.data?.work_order_number || ""} updated.`, 10);
      setTimeout(() => {
        setLoader(false);
        setState(s => ({ ...s, is_button_clicked: false }));
        goback();
      }, 1000);
    }).catch(error => {
      setLoader(false);
      setState(s => ({ ...s, is_button_clicked: false }));
      message.error(`Error occurred while updating Work order.`, 100);
    });
  }
  
  /**
   * AUTHOR: Ritesh Solanki
   */
  const filterParams = (params) => {
    for (var propName in params) {
      if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
        delete params[propName];
      }
    }
    return params
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onClear = () => {
    goback();
  }

  return (
    <Drawer
      placement={'right'}
      closable={false}
      onClose={goback}
      visible={visible_edit_workOrder}
      key={'right'}
      width={'525'}
      className="drawer-wrapper"
    >
      <div className="edit-service-drawer rdrawer">
        {loader && <Loader />}
        <React.Fragment>
          <div className="card-head flex ai-center">
            <h4> {transection_type} Work Order</h4>
            <CloseOutlined onClick={() => {
              onClear();
              goback()
            }} />
          </div>
        </React.Fragment>
        <div className="card-row flex flex-column">
          <div className="card-full">
            <React.Fragment>
              { commercial_order_line_item_type === "service" && <Location /> }
            </React.Fragment>
            
            <React.Fragment>
              <Details field_office__uuid={field_office__uuid}/>
            </React.Fragment>
            <React.Fragment>
              { commercial_order_line_item_type === "service" && <Services /> }
              { commercial_order_line_item_type === "product" && <Products /> }          
            </React.Fragment>

            <React.Fragment>
              <ServiceTotal />
            </React.Fragment>
          </div>
        </div>
        
        <React.Fragment>
          <div className="footer">
            <Button className="btn btn-brand btn-bdr" onClick={() => { onClear() }}>Cancel</Button>
            {transection_type === "Edit" &&
              <Button className={`btn btn-primary`} 
                onClick={() => {
                  console.warn('is_button_clicked', is_button_clicked)
                  if (!is_button_clicked) {
                    setState(s => ({ ...s, is_button_clicked: true }));
                    setLoader(true);
                    validate();
                  }                
                }}
              > Update Work Order </Button>
            }
            {transection_type === "Create" &&
              <Button className={`btn btn-primary`} onClick={() => validate()}> Create Work Order </Button>
            }
          </div>
        </React.Fragment>

      </div>

    </Drawer>
  )
}

function Location() {
  const ctx = useContext(PageContext);
  const { state, setState,selectedService } = ctx;
  const { location_markers, showLocation, mapZoom = 12, quoteDetail, currentPosition,commercial_service_coordinates } = state;
  /**
   * AUTHOR: Ritesh Solanki
   */
  const toggleLocation = () => {
    setState(s => ({ ...s, showLocation: !showLocation }))
  }

  return(
    <React.Fragment>
      <div onClick={() => toggleLocation()}>
        {!isEmpty(commercial_service_coordinates) ? !showLocation ? <CustomMap isView={true} markers={commercial_service_coordinates} /> : '' :
          ""
        }
      </div>
      {showLocation && <DefineCoordinates
        isViewOnly={true}
        zoom={mapZoom}
        visible={showLocation}
        quoteDetail={quoteDetail}
        onCancel={() => toggleLocation()}
        markerList={!isEmpty(commercial_service_coordinates) ? commercial_service_coordinates : !isEmpty(currentPosition) ? [] : []}
        currentPosition = {!isEmpty(currentPosition) ? [currentPosition] : [] }
        address ={!isEmpty(selectedService?.service_address?.formatted_address) ?selectedService?.service_address?.formatted_address:""}
      />
        
      }
    </React.Fragment>
  )
}

function Details(props) {
  const [technicians, setTechnicians] = useState([]);
  const ctx = useContext(PageContext);
  const { state, setState, transection_type } = ctx;
  const {
    errors,
    status,
    date,
    time,
    security_code,
    cleaning_notes,
    header_bag_price,
    roll_bag_price,
    header_bag_quantity,
    roll_bag_quantity ,
    commercial_order_line_item_type,
    currentSelectedDate,
  } = state;

  /**
   * AUTHOR: Ritesh Solanki
   */
  useEffect(() => {
    axios
      .get(`/ftech/field-technicians/`,{params: {field_office__uuid: props.field_office__uuid}})
      .then(response => {
        setTechnicians(response?.data?.results)
      })
      .catch(error => {
        console.log(error)
      })
  }, [props]);

  /**
   * AUTHOR: Ritesh Solanki
   */
  const updateTechnician = (technician_uuid) => {
    setState(s => ({ ...s, technician_uuid }))
  }
  
  return(
    <div className="form-group">
      <div className="field-group">
        <label>status<sup>*</sup></label>
        <Select
          value={state?.status}
          disabled={transection_type === 'View'}
          onChange={(e) => {
            // message.destroy();
            if (e === 'complete') {
              setState(s => ({
                ...s,
                status: e,
                time: moment("12:00 AM", ["h:mm A"])
              }))
            } else {
              setState(s => ({
                ...s,
                status: e,
                time: '',
                technician_uuid: e === "forecast" ? "" : state?.technician_uuid
              }))
            }
          }}
        >
          {map(workOrderStatus.WorkOrderStatus, (item, index) => {
            if (commercial_order_line_item_type === "service") {
              if (index > 0) {
                return (
                  <Option key={index} value={item.value}>{item.label}</Option>
                )
              }
            } else {
              if (index > 2) {
                return (
                  <Option key={index} value={item.value}>{item.label}</Option>
                )
              }
            }
          })}
        </Select>
      </div>
      
      <div className="field-group">
        {commercial_order_line_item_type === "service" 
          ? <label>Assigned Technician{(status === 'scheduled' || status === 'incomplete' || status === 'complete') && <sup>*</sup>}</label>
          : <label>Assigned Technician</label>
        }
        <Select
          showSearch
          placeholder="Not assigned"
          optionFilterProp="children"
          onChange={(e) => {
            updateTechnician(e)
          }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          value={state?.technician_uuid || undefined}
          disabled={state?.status === "forecast" || transection_type === 'View'}
        >
          {
            technicians?.map((technician, index) => {
              return <Option key={index} value={technician.uuid}>{`${technician?.user?.first_name} ${technician?.user?.last_name}`}</Option>
            })
          }
        </Select>
        {errors?.['technician'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['technician']}</label> : ''}
      </div>

      <div className="">
        <div style={{ display: 'flex' }}>
          <div className="field-group" style={{ width: "50%", paddingRight: 5 }}>
            <label>Work Order Date<sup>*</sup></label>
            <DatePicker
              style={{ 'width': '100%' }}
              disabled={transection_type === 'View'}
              minDate={moment().toDate()}
              format="MMM DD,YYYY"
              suffixIcon={<i className="las la-calendar"></i>}
              allowClear={true}
              value={date ? moment(date) : null}
              onBlur={(e) => {
                if(transection_type !== 'View')
                {
                  setState(s => ({ ...s, date: currentSelectedDate }))
                }
              }}
              onClick={(e) => {
                if(transection_type !== 'View')
                {
                  setState(s => ({ ...s, date: null }))
                }
              }}
              onChange={(e) => {
                if (e) {
                  setState(s => ({ ...s, date: e,currentSelectedDate:e }))
                } else {
                  setState(s => ({ ...s, date: null,currentSelectedDate:null }))
                }
              }}
            />
            {errors?.['date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['date']}</label> : ''}
          </div>
          {commercial_order_line_item_type === "service" && <div className="field-group" style={{ width: "50%", paddingLeft: 5 }}>
            <label>Time {(status === 'scheduled' || status === 'incomplete' || status === 'complete') && <sup>*</sup>}</label>
            <TimePicker
              className="swhite"
              placeholder={'--:-- AM/PM'}
              value={time}
              onChange={(e) => {
                setState(s => ({ ...s, time: e }))
              }}
              allowClear={["forecast", "canceled"].includes(status)}
              // minuteStep={1}
              // allowClear={true}
              format={'h:mm A'}
              disabled={status === "forecast" || transection_type === 'View'}
            />
            {errors?.['time'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['time']}</label> : ''}
          </div>}
        </div>
        {errors?.['time_past'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_past']}</label> : ''}
        {errors?.['time_future'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_future']}</label> : ''}
      </div>

      {commercial_order_line_item_type === "service" && <div className="field-group">
        <label>Security Code</label>
        <Input
          disabled={transection_type === 'View'}
          value={state.security_code}
          placeholder="Security code"
          onChange={(e) => {
            if (e) {
              setState(s => ({ ...s, security_code: e?.target?.value }))
            } else {
              setState(s => ({ ...s, security_code: '' }))
            }
            
          }}
        />
      </div>}
      
      <div className="field-group">
        <label>Notes</label>
        <TextArea
          className="form-control service-textarea"
          disabled={transection_type === 'View'}
          value={state.cleaning_notes}
          placeholder="Enter any additional service notes here"
          onChange={(e) => {
            if (e) {
              setState(s => ({ ...s, cleaning_notes: e?.target?.value }))
            } else {
              setState(s => ({ ...s, cleaning_notes: '' }))
            }
            
          }}
        ></TextArea>
      </div>

      {commercial_order_line_item_type === "service" && <div className="">
        <div style={{ display: 'flex' }}>
          <div className="field-group mb-10" style={{ width: "50%", paddingRight: 5 }}>
            <label>Header Bag Pricing<sup>*</sup></label>
            <div className="position-relative">
              <CurrencyFormat 
                value={state.header_bag_price} 
                thousandSeparator={true} 
                disabled={transection_type === 'View'}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => { 
                  const { formattedValue, value } = values;
                  setState(s => ({ ...s, header_bag_price: value }))
                }}/>
            </div>
            {errors?.['header_bag_price'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['header_bag_price']}</label> : ''}
          </div>
          <div className="field-group mb-10" style={{ width: "50%", paddingLeft: 5 }}>
            <label>Roll Bag Pricing<sup>*</sup></label>
            <div className="position-relative">
              <CurrencyFormat 
                value={state.roll_bag_price} 
                thousandSeparator={true} 
                disabled={transection_type === 'View'}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => { 
                  const { formattedValue, value } = values;
                  setState(s => ({ ...s, roll_bag_price: value }))
                }}/>
            </div>
            {errors?.['roll_bag_price'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['roll_bag_price']}</label> : ''}
          </div>

        </div>
      </div>}

      {commercial_order_line_item_type === "service" &&  <div className="">
        <div style={{ display: 'flex' }}>
          <div className="field-group mb-10" style={{ width: "50%", paddingRight: 5 }}>
            <label>Quantity Header Bags Sold<sup>*</sup></label>
            <CurrencyFormat 
              value={state.header_bag_quantity} 
              disabled={transection_type === 'View'}
              allowNegative={false}
              placeholder={"0"}
              onValueChange={(values) => { 
                const { formattedValue, value } = values;
                setState(s => ({ ...s, header_bag_quantity: value }))
              }}/>
            {errors?.['header_bag_quantity'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['header_bag_quantity']}</label> : ''}
          </div>

          <div className="field-group mb-10" style={{ width: "50%", paddingLeft: 5 }}>
            <label>Quantity Roll Bags Sold<sup>*</sup></label>
            <CurrencyFormat 
              value={state.roll_bag_quantity} 
              disabled={transection_type === 'View'}
              allowNegative={false}
              placeholder={"0"}
              onValueChange={(values) => { 
                const { formattedValue, value } = values;
                setState(s => ({ ...s, roll_bag_quantity: value }))
              }}/>
            {errors?.['roll_bag_quantity'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['roll_bag_quantity']}</label> : ''}
          </div>

        </div>
      </div>}
      {commercial_order_line_item_type === "service" &&
      
      <div>
        <div style={{ display: 'flex' }}>
          <div className="field-group mb-10" style={{ width: "50%", paddingRight: 5 }}>
            <span className="flex ai-center">
              <b style={{ fontSize:"98%"}}>Total Header Bags Sold</b>
            
              <b className="mr-0" style={{ fontSize:"98%"}}>$ {state.header_bag_quantity*state.header_bag_price}</b>
            </span>
          </div>

          <div className="field-group mb-10" style={{ width: "50%", paddingLeft: 5 }}>
            <span className="flex ai-center">
              <b style={{ fontSize:"98%"}}>Total Roll Bags Sold</b>
              <b className="mr-0" style={{ fontSize:"98%"}}>$ {state.roll_bag_quantity*state.roll_bag_price}</b>
            </span>
          </div>

        </div>
      </div>
      }
    </div>
  )
}

function Services() {
  const ctx = useContext(PageContext);
  const { state, setState,selectedService } = ctx;
  const { transection_type, errors, commercial_work_order_line_items = [], commercial_order_line_item_type,currentPosition,showCoordinates,mapZoom,coordinate,quoteDetail,commercial_service_coordinates } = state;

  /**
   * AUTHOR: Ritesh Solanki
   */
  const setRows = () => {
    let commercial_work_order_line_items_ = [...commercial_work_order_line_items];
    commercial_work_order_line_items_.unshift({ id: 0, miscellaneous_services: [], created_at: moment().format("YYYY-MM-DD hh:mm:ss"), modified_at: '', uuid: '', service_name: '', model: '', item_type: commercial_order_line_item_type, description: '', rate: 0, quantity: 0, total: 0, coordinates: null, commercial_work_order: '',totalCoordinates:0 });
    setState(s => ({ ...s, commercial_work_order_line_items:commercial_work_order_line_items_ }));
  }

  const setMiscellaneousRows = (index) => {
    let commercial_work_order_line_items_ = [...commercial_work_order_line_items];
    let item = {...commercial_work_order_line_items_[index]}
    let miscellaneous_services = [...item.miscellaneous_services];

    miscellaneous_services.push({mis_type:'service', price: '', item: '' });

    item.miscellaneous_services = [...miscellaneous_services];
    commercial_work_order_line_items_[index] = item;
    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowService = (index) => {
    let commercial_work_order_line_items_ = [...commercial_work_order_line_items];
    commercial_work_order_line_items_.splice(index, 1);
    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] }));
  }

  const onRowDataChange = (value, parentIndex, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    let parent = {...commercial_work_order_line_items_[parentIndex]};
    let miscellaneous_services = [...parent.miscellaneous_services];
    let item = {...miscellaneous_services[index]};

    item[key] = value;
    miscellaneous_services[index] = item;

    let miscTotal = 0;

    map(commercial_work_order_line_items_[parentIndex]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    });

    const { quantity, rate } = parent;
    parent['total'] =(quantity && rate) ? ((quantity * rate) + miscTotal) : 0.00;
    parent.miscellaneous_services = miscellaneous_services;
    commercial_work_order_line_items_[parentIndex] = parent;

    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] }))
  }
  
  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowMisc = (parentIndex, childIndex) => {
    commercial_work_order_line_items_ = [...commercial_work_order_line_items];
    commercial_work_order_line_items_[parentIndex].miscellaneous_services.splice(childIndex, 1);

    let miscTotal=0;

    map(commercial_work_order_line_items_[parentIndex]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    });

    const { quantity, rate } = commercial_work_order_line_items_[parentIndex];
    commercial_work_order_line_items_[parentIndex]['total'] =(quantity && rate) ? ((quantity * rate) + miscTotal) : 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderItemRow = (parentIndex, miscellaneous_services) => {
    return (<React.Fragment> {map(miscellaneous_services, (item, childIndex) => {
      return (
        <div className="divrow" key={`items${childIndex}`} style={{ marginLeft: "0px", marginBottom: "10px" }}>
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <Select
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                disabled={transection_type === 'View'}
                value={item?.mis_type?item?.mis_type:"Select Type"}
                onChange={(event) => {
                  onRowDataChange(event, parentIndex, childIndex, "mis_type")
                }}
              >
                <Option value="service">Service</Option>
                <Option value="product">Product</Option>
              </Select>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`]===`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type must be one of the following values: product, service`?"Select one":`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <input
                type="text"
                value={item?.item}
                disabled={transection_type === 'View'}
                name="item"
                placeholder="Item"
                onChange={(event) => {
                  event.persist();
                  if (event) {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscellaneous_services"][childIndex]["item"] = event?.target?.value;
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  } else {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscellaneous_services"][childIndex]["item"] = "";
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  }
                }}
              />
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].item`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pl-5">
            <div className="sprice mr-0" style={{ position: 'relative' }}>
              <CurrencyFormat 
                value={item?.price} 
                thousandSeparator={true} 
                disabled={transection_type === 'View'}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={true}
                placeholder={"$ 0.00"}
                onValueChange={(values) => {
                  const { formattedValue, value } = values;
                  onRowDataChange(value, parentIndex, childIndex, "price")
                }}/>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].price`]}</label> : ''}
            </div>
          </div>
          {transection_type !== "View" &&<CloseOutlined style={{ marginTop: "14px" }} onClick={() => onDeleteRowMisc(parentIndex, childIndex)}></CloseOutlined>}
        </div>
      )
    })}</React.Fragment>)
  }

  /**
   * AUTHOR: Ritesh Solanki
   * @param {*} value 
   * @param {*} index 
   * @param {*} key 
   */
  const onLineItemsChanged = (value, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    const item = {...commercial_work_order_line_items_[index]};
    item[key] = value;

    const { quantity, rate } = item;
    const total = (+quantity * +rate);

    let miscTotal=0;
    map(commercial_work_order_line_items_[index]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    });

    item['total'] = total+miscTotal;
    commercial_work_order_line_items_[index] = {...item};
    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] }));
  }

  // To toggle coordinate modal
  const toggleCoordinates = (index) => {
    const {coordinate,showCoordinates,commercial_work_order_line_items} = state ; 
    let markers = commercial_work_order_line_items[index].markers;
    Object.assign(coordinate, {markers});
    setState(s => ({ ...s, showCoordinates: !showCoordinates,coordinate:{markers},coordinateIndex:index }))
  }

  // store drop pins
  const onSaveMarkersCoordinates = (markers,mapZoom) => {
    let markerLength = markers.length;
    let coordString = "SRID=4326;MULTIPOINT("
    map(markers, (x , i) => {
        
      if(markerLength === i+1){
        coordString += x.lat + " " + x.lng +")";
      }else{
        coordString += x.lat + " " + x.lng +",";
      }
    });
    const {coordinateIndex} = state; 
    if(markerLength > 0){
      commercial_work_order_line_items[coordinateIndex].coordinates = coordString ;
      commercial_work_order_line_items[coordinateIndex].totalCoordinates = markerLength ;
      commercial_work_order_line_items[coordinateIndex].markers = markers ;
    }
    else{
      commercial_work_order_line_items[coordinateIndex].coordinates = null ;
      commercial_work_order_line_items[coordinateIndex].totalCoordinates = markerLength ;
      commercial_work_order_line_items[coordinateIndex].markers = markers ;
    }
    let allCoordinates=[];
    map(commercial_work_order_line_items, (obj, index) => {
      allCoordinates=[...allCoordinates, ...obj.markers]
    })
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items,commercial_service_coordinates:allCoordinates,mapZoom:mapZoom }))

  
  }
  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderLineItems = () => {
    return (<React.Fragment> {map(commercial_work_order_line_items, (obj, index) => {
      return (
        <div className="ord-serive-block" key={`line_items${index}`}>
          <div className="ord-serive-top">
            <div className="card-title flex ai-center mb-10">
              <h4 className="m-0">Service</h4>
              {transection_type !== "View" &&<div className="ant-ico-del" onClick={() => onDeleteRowService(index)}>
                <DeleteFilled  style={{color:"red"}}/>
                Delete
              </div>}
            </div>
            <div className="form-group">
              <div className="fitem">
                <label>Service<sup>*</sup></label>
                <Select
                  showArrow
                  disabled={transection_type === 'View'}
                  virtual={false}
                  style={{ width: '100%' }}
                  value={obj.service_name ? obj?.service_name : undefined}
                  placeholder={'Select Service'}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e, index, "service_name");
                    } else {
                      onLineItemsChanged('', index, "service_name");
                    }
                  }}
                >
                  {
                    SERVICE_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                  }
                </Select>
                {errors?.[`commercial_work_order_line_items[${index}].service_name`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].service_name`]}</label> : ''}
              </div>

              <div className="fitem">
                <label htmlFor={"description"}>Description</label>
                <input
                  disabled={transection_type === 'View'}
                  type="text"
                  className={'form-control mb-10'}
                  placeholder={'Description'}
                  name="description"
                  id="description"
                  value={obj.description}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e.target.value, index, "description")
                    } else {
                      onLineItemsChanged('', index, "description")
                    }
                  }}
                />
              </div>

              <div className="fitem">
                <label htmlFor={"coordinates"}>Coordinates<sup>*</sup></label>
                <div className="position-relative">
                  <input
                    type="text"
                    defaultValue={0}
                    disabled={transection_type === 'View'}
                    placeholder={'Coordinates'}
                    name="coordinates"
                    id="coordinates"
                    value={obj.totalCoordinates}
                    readOnly={true}
                    onClick={(e) => {
                      if (e) {
                        toggleCoordinates(index)
                      } else {
                        toggleCoordinates(index)
                      }
                    }}
                  />
                  {transection_type !== 'View' && <a href="/#" className="cord-edit" onClick={(e) => { e.preventDefault(); toggleCoordinates(index)}}>
                    <img src={EditGreen} alt=""  style={{ marginRight: '6px' }} />
                    Edit
                  </a>}
                </div>
                {errors?.[`commercial_work_order_line_items[${index}].coordinates`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].coordinates`]}</label> : ''}
              </div>
              
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Quantity<sup>*</sup></label>
                  <CurrencyFormat 
                    value={obj?.quantity} 
                    defaultValue={0}
                    disabled={transection_type === 'View'}
                    allowNegative={false}
                    placeholder={"0"}
                    onBlur={(e) => { 
                      if(e?.currentTarget?.value===""){
                        onLineItemsChanged(0, index, "quantity")
                      }
                    }}
                    onValueChange={(values) => { 
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "quantity")
                    }}/>
                  {errors?.[`commercial_work_order_line_items[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].quantity`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Rate<sup>*</sup></label>
                  <CurrencyFormat 
                    value={obj?.rate} 
                    thousandSeparator={true} 
                    disabled={transection_type === 'View'}
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={true}
                    placeholder={"$ 0.00"}
                    onBlur={(e) => { 
                      if(e?.currentTarget?.value===""){
                        onLineItemsChanged(0, index, "rate")
                      }
                    }}
                    onValueChange={(values) => { 
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "rate")
                    }}/>
                  {errors?.[`commercial_work_order_line_items[${index}].rate`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].rate`]}</label> : ''}
                </div>
              </div>
            </div>
            <div className="mb-8">
              <h6 className="mb-8">Miscellaneous</h6>
              {renderItemRow(index, obj?.miscellaneous_services)}
              {
                transection_type !== "View" &&
                  <a
                    href="/#"
                    className="addmore-btn"
                    disabled={transection_type === "View"}
                    onClick={(e) => { e.preventDefault(); setMiscellaneousRows(index) }}
                  >
                    <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }} />Add Item
                  </a>
              }
            </div>
          </div>
          <div className="subs flex ai-center fs-13">
            <b>Service Total </b>
            <b className="mr-0">$ {formatToCurrency(obj?.total)}</b>
          </div>
        </div>
      )
    })}</React.Fragment>)
  }

  return(
    <React.Fragment>
      {transection_type !== "View" && <div className="form-group">
        <div className="field-group mb-10" style={{ width: "100%"}}>
          <div className="add-service-btn">
            <a role="button" href="/#" disabled={transection_type === "View"} onClick={(e) => { e.preventDefault();setRows();}}>
              <img src={addGreenCircle} alt="" style={{marginRight: '6px'}}></img> 
              Add Service
            </a>
          </div>
        </div>
      </div>}
      {showCoordinates && <DefineCoordinates
        zoom={mapZoom}
        visible={showCoordinates}
        quoteDetail={quoteDetail}
        onCancel={() => toggleCoordinates(0)}
        onSave={(markers, mapZoom) => {
          onSaveMarkersCoordinates(markers,mapZoom);
        }}
        markerList={!isEmpty(coordinate.markers) ? coordinate.markers : !isEmpty(currentPosition) ? [] : []}
        currentPosition = {!isEmpty(currentPosition) ? [currentPosition] : [] }
        address ={!isEmpty(selectedService?.service_address?.formatted_address) ?selectedService?.service_address?.formatted_address:""}
      />}
      {renderLineItems()}
    </React.Fragment>
  )
}

function Products() {
  const ctx = useContext(PageContext);
  const { state, setState } = ctx;
  const { transection_type, errors, commercial_work_order_line_items = [], commercial_order_line_item_type } = state;
  
  /**
   * AUTHOR: Ritesh Solanki
   */
  const setRows = () => {
    commercial_work_order_line_items.unshift({ id: 0, miscellaneous_services: [], created_at: moment().format("YYYY-MM-DD hh:mm:ss"), modified_at: '', uuid: '', service_name: '', model: '', item_type: commercial_order_line_item_type, description: '', rate: 0, quantity: 0, total: 0, shipping_and_handling: 0, commercial_work_order: '' });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const setMiscellaneousRows = (index) => {
    commercial_work_order_line_items[index].miscellaneous_services.push({mis_type:'product', price: '', item: '' });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowService = (index) => {
    commercial_work_order_line_items.splice(index, 1);
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowMisc = (parentIndex, childIndex) => {
    commercial_work_order_line_items[parentIndex].miscellaneous_services.splice(childIndex, 1);
    let miscTotal=0;
    map(commercial_work_order_line_items[parentIndex]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    let total = 0;
    const { quantity, rate, shipping_and_handling } = commercial_work_order_line_items[parentIndex];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (shipping_and_handling) {
      total += +shipping_and_handling;
    }
    if (miscTotal) {
      total += miscTotal;
    }
    commercial_work_order_line_items[parentIndex]['total'] = total || 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const onLineItemsChanged = (value, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    commercial_work_order_line_items_[index][key] = value;
    let miscTotal=0;
    map(commercial_work_order_line_items_[index]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    let total = 0;
    const { quantity = 0, rate = 0, shipping_and_handling = 0 } = commercial_work_order_line_items_[index];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (shipping_and_handling) {
      total += +shipping_and_handling;
    }
    if (miscTotal) {
      total += miscTotal;
    }
    commercial_work_order_line_items_[index]['total'] = total;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
  }

  const onRowDataChange = (value, parentIndex, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    commercial_work_order_line_items_[parentIndex]["miscellaneous_services"][index][key] = value;
    let miscTotal=0;
    map(commercial_work_order_line_items_[parentIndex]["miscellaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    let total = 0;
    const { quantity = 0, rate = 0, shipping_and_handling = 0 } = commercial_work_order_line_items_[parentIndex];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (shipping_and_handling) {
      total += +shipping_and_handling;
    }
    if (miscTotal) {
      total += miscTotal;
    }
    commercial_work_order_line_items_[parentIndex]['total'] = total || 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
  }

  /**
   * AUTHOR: Ritesh Solanki
   * @param {*} parentIndex 
   * @param {*} miscellaneous_services 
   */
  const renderItemRow = (parentIndex, miscellaneous_services) => {
    return (<React.Fragment> {map(miscellaneous_services, (item, childIndex) => {
      return (
        <div className="divrow" key={`items${childIndex}`} style={{ marginLeft: "0px", marginBottom: "10px" }}>
          {/* <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <Select
                disabled={true}
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                value={item?.mis_type?item?.mis_type:"Select Type"}
                onChange={(event) => {
                  onRowDataChange(event, parentIndex, childIndex, "mis_type")
                }}
              >
              </Select>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`]===`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type must be one of the following values: product, service`?"Select one":`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].mis_type`}</label> : ''}
            </div>
          </div> */}
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <input
                type="text"
                value={item?.item}
                disabled={transection_type === 'View'}
                name="item"
                placeholder="Item"
                onChange={(event) => {
                  event.persist();
                  if (event) {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscellaneous_services"][childIndex]["item"] = event?.target?.value;
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  } else {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscellaneous_services"][childIndex]["item"] = "";
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  }
                }}
              />
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].item`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pl-5">
            <div className="sprice mr-0" style={{ position: 'relative' }}>
              <CurrencyFormat 
                value={item?.price} 
                thousandSeparator={true} 
                disabled={transection_type === 'View'}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={true}
                placeholder={"$ 0.00"}
                onValueChange={(values) => { 
                  const { formattedValue, value } = values;
                  onRowDataChange(value, parentIndex, childIndex, "price")
                }}/>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscellaneous_services[${childIndex}].price`]}</label> : ''}
            </div>
          </div>
          {transection_type !== "View" && <CloseOutlined style={{ marginTop: "14px" }} onClick={() => onDeleteRowMisc(parentIndex, childIndex)}></CloseOutlined>}
        </div>
      )
    })}</React.Fragment>)
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderLineItems = () => {
    return (<React.Fragment> {map(commercial_work_order_line_items, (obj, index) => {
      return (
        <div className="ord-serive-block" key={`line_items${index}`}>
          <div className="ord-serive-top">
            <div className="card-title flex ai-center mb-10">
              <h4 className="m-0">Product</h4>
              {transection_type !== "View" &&<div className="ant-ico-del" onClick={() => onDeleteRowService(index)}>
                <DeleteFilled  style={{color:"red"}}/>
                Delete
              </div>}
            </div>
            <div className="form-group">
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label>Product<sup>*</sup></label>
                  <Select
                    showArrow
                    disabled={transection_type === 'View'}
                    virtual={false}
                    style={{ width: '100%' }}
                    value={obj.service_name ? obj?.service_name : undefined}
                    placeholder={'Select Product'}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "service_name")
                      } else {
                        onLineItemsChanged('', index, "service_name")
                      }
                    }}
                  >
                    {
                      PRODUCT_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                    }
                  </Select>
                  {errors?.[`commercial_work_order_line_items[${index}].service_name`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].service_name`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label>Model<sup>*</sup></label>
                  <Select
                    showArrow
                    disabled={transection_type === 'View'}
                    virtual={false}
                    style={{ width: '100%' }}
                    value={obj.model ? obj?.model : undefined}
                    placeholder={'Select Model'}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "model")
                      } else{
                        onLineItemsChanged('', index, "model")
                      }
                    }}
                  >
                    <Option value="mounted">Mounted</Option>
                    <Option value="header_bags">Header Bags</Option>
                  </Select>
                  {errors?.[`commercial_work_order_line_items[${index}].model`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].model`]}</label> : ''}
                </div>

              </div>

              <div className="fitem">
                <label htmlFor={"description"}>Description</label>
                <input
                  disabled={transection_type === 'View'}
                  type="text"
                  className={'form-control mb-10'}
                  placeholder={'Description'}
                  name="description"
                  id="description"
                  value={obj.description}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e?.target?.value, index, "description")
                    } else {
                      onLineItemsChanged('', index, "description")
                    }
                  }}
                />
              </div>
              
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Quantity<sup>*</sup></label>
                  <CurrencyFormat 
                    value={obj.quantity} 
                    allowNegative={false}
                    defaultValue={0}
                    disabled={transection_type === 'View'}
                    placeholder={"0"}
                    onBlur={(e) => { 
                      if(e?.currentTarget?.value===""){
                        onLineItemsChanged(0, index, "quantity")
                      }
                    }}
                    onValueChange={(values) => { 
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "quantity")
                    }}/>
                  {errors?.[`commercial_work_order_line_items[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].quantity`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label htmlFor={"rate"}>Rate<sup>*</sup></label>
                  <CurrencyFormat 
                    value={obj?.rate} 
                    thousandSeparator={true} 
                    disabled={transection_type === 'View'}
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={true}
                    placeholder={"$ 0.00"}
                    onBlur={(e) => { 
                      if(e?.currentTarget?.value===""){
                        onLineItemsChanged(0, index, "rate")
                      }
                    }}
                    onValueChange={(values) => { 
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "rate")
                    }}/>
                  {errors?.[`commercial_work_order_line_items[${index}].rate`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].rate`]}</label> : ''}
                </div>
                <div className="fitem half-fitem">
                  <label htmlFor={"shipping_and_handling"}>S&H<sup>*</sup></label>
                  <CurrencyFormat 
                    value={obj?.shipping_and_handling} 
                    disabled={transection_type === 'View'}
                    thousandSeparator={true} 
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    placeholder={"$ 0.00"}
                    onBlur={(e) => { 
                      if(e?.currentTarget?.value===""){
                        onLineItemsChanged(0, index, "shipping_and_handling")
                      }
                    }}
                    onValueChange={(values) => { 
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "shipping_and_handling")
                    }}/>
                  {errors?.[`commercial_work_order_line_items[${index}].shipping_and_handling`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].shipping_and_handling`]}</label> : ''}
                </div>
              </div>
            </div>
            <div className="mb-8">
              <h6 className="mb-8">Miscellaneous</h6>
              {renderItemRow(index, obj?.miscellaneous_services)}
              {transection_type !== "View" &&<a className="addmore-btn" href="/#" disabled={transection_type === "View"} onClick={(e) => { e.preventDefault(); setMiscellaneousRows(index) }}>
                <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }} />Add Item
              </a>}
            </div>
          </div>
          <div className="subs flex ai-center fs-13">
            <b>Product Total </b>
            <b className="mr-0">{ obj?.total ? `$ ${obj?.total}` : `$ 0.00` }</b>
          </div>
          
        </div>
      )
    })}</React.Fragment>)
  }

  return(
    <React.Fragment>
      {transection_type !== "View" && <div className="form-group">
        <div className="field-group" style={{ width: "100%", paddingRight: 5 }}>
          <div className="add-service-btn">
            <a role="button" href="/#" onClick={(e) => { e.preventDefault();setRows()}}>
              <img src={addGreenCircle} alt="" style={{marginRight: '6px'}}></img> 
              Add Product
            </a>
          </div>
        </div>
      </div>}
      {renderLineItems()}
    </React.Fragment>
  )
}

function ServiceTotal() {
  const ctx = useContext(PageContext);
  const { state, setState } = ctx;
  const { commercial_work_order_line_items,commercial_order_line_item_type } = state;
  let total=0;
  var result = [];
  if(commercial_work_order_line_items!==undefined)
  {
    commercial_work_order_line_items.reduce(function(res, value) {
      if (!res[value.service_name]) {
        res[value.service_name] = { service_name: value.service_name, total: 0 };
        result.push(res[value.service_name])
      }
      res[value.service_name].total += value.total;
      return res;
    }, {});
  }

  const finalTotal = (serviceTotal) => {
    const { header_bag_quantity, header_bag_price, roll_bag_quantity, roll_bag_price} = state;
    if (header_bag_quantity > 0 && header_bag_price > 0) {
      serviceTotal = serviceTotal + (header_bag_quantity * header_bag_price);
    }
    if (roll_bag_quantity > 0 && roll_bag_price > 0) {
      serviceTotal = serviceTotal + (roll_bag_quantity * roll_bag_price);
    }
    return formatToCurrency(serviceTotal);
  }

  return(
    <div className="mt-10 serv-ord-total">
      <div className="sdetail fs-13">
        {map(result, (obj, index) => {
          total+=obj.total;
          return (
            obj.service_name!=='' && <div key={`ServiceTotal_items${index}`} className="subs flex mt-8">
              {commercial_order_line_item_type === "service" && <span className="service-type-title">{SERVICE_TYPE[obj.service_name]}</span>}
              {commercial_order_line_item_type === "product" && <span className="service-type-title">{PRODUCT_TYPE[obj.service_name]}</span>}
              <div className="flex" key={`clean_area_total`}>
                <div className="flex-1"></div>
                <div className="">$ {formatToCurrency(obj.total)}</div>
              </div>
            </div>
          ) })}
        {commercial_order_line_item_type === "service" && <React.Fragment>
          {state.header_bag_quantity > 0 && state.header_bag_price > 0 && <div key={`ServiceTotal_items_header`} className="subs flex mt-8">
            <span className="service-type-title">Total Header Bags Price</span>
            <div className="flex">
              <div className="flex-1"></div>
              <div className="">$ {state.header_bag_quantity*state.header_bag_price}</div>
            </div>
          </div>}
          {state.roll_bag_quantity > 0 && state.roll_bag_price > 0 && <div key={`ServiceTotal_items_roll`} className="subs flex mt-8">
            <span className="service-type-title">Total Roll Bags Price</span>
            <div className="flex">
              <div className="flex-1"></div>
              <div className="">$ {state.roll_bag_quantity*state.roll_bag_price}</div>
            </div>
          </div>}
        </React.Fragment>
        }
        <div className="subs mt-8">
          <span className="flex ai-center">
            {commercial_order_line_item_type === "service" &&<b>Servicer Order Total (excl. tax)</b>}
            {commercial_order_line_item_type !== "service" &&<b>Work Order Total (excl. tax)</b>}
            <b className="mr-0">$ {finalTotal(total)}</b>
          </span>
        </div>
      </div>
    </div>
  )
}
